
<app-modal-wrapper (close)="close.emit()">
  <app-modal-content [modalTitle]="config.title || ''"
                     [hiddenButtons]="['success', 'close']"
                     (closeModal)="close.emit()">

    <figure>
      <img [src]="config.url" alt="">
    </figure>
  </app-modal-content>
</app-modal-wrapper>
